import { useRef, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { Accordion, AccordionSummary, AccordionDetails } from '@mui/material';

import E1RegularCheck from './E1RegularCheck/E1RegularCheck';
import E2DataFlowActivitiesProcedure from './E2DataFlowActivitiesProcedure/E2DataFlowActivitiesProcedure';
import E3RiskAssessmentprocedure from './E3RiskAssessmentprocedure/E3RiskAssessmentprocedure';
import E4ControlActivities from './E4ControlActivities/E4ControlActivities';
import E5ReviewAndValidation from './E5ReviewAndValidation/E5ReviewAndValidation';
import E6CorrectionAndCorrective from './E6CorrectionsAndCorrective/E6CorrectionsAndCorrective';
import E7OutsourcedActivities from './E7OutsourcedActivities/E7OutsourcedActivities';
import E8Documentation from './E8Documentation/E8Documentation';

const Management = ({ data, refetchMonitoringData ,vesselMstId}) => {
    const [expandedPanel, setExpandedPanel] = useState('panel1');

    const autoSaveForE1 = useRef();
    const autoSaveForE2 = useRef();
    const autoSaveForE3 = useRef();
    const autoSaveForE4 = useRef();
    const autoSaveForE5 = useRef();
    const autoSaveForE6 = useRef();
    const autoSaveForE7 = useRef();
    const autoSaveForE8 = useRef();

    const handleChange = (panel) => async (_, isExpanded) => {
        let isSubmitSuccess = true;

        if (expandedPanel === 'panel1' && autoSaveForE1.current?.submitAndCheck) {
            isSubmitSuccess = await autoSaveForE1.current.submitAndCheck();
        } else if (expandedPanel === 'panel2' && autoSaveForE2.current?.submitAndCheck) {
            isSubmitSuccess = await autoSaveForE2.current.submitAndCheck();
        } else if (expandedPanel === 'panel3' && autoSaveForE3.current?.submitAndCheck) {
            isSubmitSuccess = await autoSaveForE3.current.submitAndCheck();
        } else if (expandedPanel === 'panel4' && autoSaveForE4.current?.submitAndCheck) {
            isSubmitSuccess = await autoSaveForE4.current.submitAndCheck();
        } else if (expandedPanel === 'panel5' && autoSaveForE5.current?.submitAndCheck) {
            isSubmitSuccess = await autoSaveForE5.current.submitAndCheck();
        } else if (expandedPanel === 'panel6' && autoSaveForE6.current?.submitAndCheck) {
            isSubmitSuccess = await autoSaveForE6.current.submitAndCheck();
        } else if (expandedPanel === 'panel7' && autoSaveForE7.current?.submitAndCheck) {
            isSubmitSuccess = await autoSaveForE7.current.submitAndCheck();
        } else if (expandedPanel === 'panel8' && autoSaveForE8.current?.submitAndCheck) {
            isSubmitSuccess = await autoSaveForE8.current.submitAndCheck();
        }
        if (!isSubmitSuccess) return;
        setExpandedPanel(isExpanded ? panel : false);
    };

    const methods = useForm({
        mode: 'onBlur',
        defaultValues: {
        },
    });

    const renderTitleWithIcon = (panel, title) => (
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <span style={{ fontSize: '20px', fontWeight: 'bold' }}>
                {expandedPanel === panel ? '−' : '+'}
            </span>
            <p className="fuel-cons">{title}</p>
        </div>
    );

    return (
        <FormProvider {...methods}>
            <form>
                <Accordion defaultExpanded expanded={expandedPanel === 'panel1'} onChange={handleChange('panel1')} className="mt-3">
                    <AccordionSummary className="accordion-header">
                        {renderTitleWithIcon('panel1', 'E.1 Regular check of the adequacy of the monitoring plan')}
                    </AccordionSummary>
                    <AccordionDetails>
                        <E1RegularCheck
                            e1MonitoringPlanChecks={data?.e1MonitoringPlanChecks}
                            vesselMstId={vesselMstId}
                            refetchMonitoringData={refetchMonitoringData}
                            ref={autoSaveForE1}
                        />
                    </AccordionDetails>
                </Accordion>

                <Accordion expanded={expandedPanel === 'panel2'} onChange={handleChange('panel2')} className="mt-3">
                    <AccordionSummary
                        className="accordion-header"
                    >
                        {renderTitleWithIcon('panel2', 'E.2 Procedures for data flow activities')}
                    </AccordionSummary>
                    <AccordionDetails>
                        <E2DataFlowActivitiesProcedure
                            e2DataFlowProcedures={data?.e2DataFlowProcedures}
                            vesselMstId={vesselMstId}
                            refetchMonitoringData={refetchMonitoringData}
                            ref={autoSaveForE2}
                        /></AccordionDetails>
                </Accordion>

                <Accordion expanded={expandedPanel === 'panel3'} onChange={handleChange('panel3')} className="mt-3">
                    <AccordionSummary
                        className="accordion-header"
                    >
                        {renderTitleWithIcon('panel3', 'E.3 Procedures for risk assessment')}
                    </AccordionSummary>
                    <AccordionDetails>
                        <E3RiskAssessmentprocedure
                            e3RiskAssessmentProcedures={data?.e3RiskAssessmentProcedures}
                            vesselMstId={vesselMstId}
                            refetchMonitoringData={refetchMonitoringData}
                            ref={autoSaveForE3}
                        />
                    </AccordionDetails>
                </Accordion>

                <Accordion expanded={expandedPanel === 'panel4'} onChange={handleChange('panel4')} className="mt-3">
                    <AccordionSummary
                        className="accordion-header"
                    >
                        {renderTitleWithIcon('panel4', 'E.4 Control activities: Quality assurance and reliability of information technology')}
                    </AccordionSummary>
                    <AccordionDetails>
                        <E4ControlActivities
                            e4ControlActivities={data?.e4ControlActivities}
                            vesselMstId={vesselMstId}
                            refetchMonitoringData={refetchMonitoringData}
                            ref={autoSaveForE4}
                        /></AccordionDetails>
                </Accordion>

                <Accordion expanded={expandedPanel === 'panel5'} onChange={handleChange('panel5')} className="mt-3">
                    <AccordionSummary
                        className="accordion-header"
                    >
                        {renderTitleWithIcon('panel5', 'E.5 Control activities: Internal reviews and validation of data relevant to Regulation (EU) 2015/757')}
                    </AccordionSummary>
                    <AccordionDetails><E5ReviewAndValidation ref={autoSaveForE5} vesselMstId={vesselMstId} E5ReviewAndValidationData={data?.e5ControlActivities} refetchMonitoringData={refetchMonitoringData} />
                    </AccordionDetails>
                </Accordion>

                <Accordion expanded={expandedPanel === 'panel6'} onChange={handleChange('panel6')} className="mt-3">
                    <AccordionSummary
                        className="accordion-header"
                    >
                        {renderTitleWithIcon('panel6', 'E.6 Control activities: Corrections and corrective actions')}
                    </AccordionSummary>
                    <AccordionDetails><E6CorrectionAndCorrective ref={autoSaveForE6} vesselMstId={vesselMstId} E6CorrectionAndCorrectiveData={data?.e6ControlActivities} refetchMonitoringData={refetchMonitoringData} />
                    </AccordionDetails>
                </Accordion>

                <Accordion expanded={expandedPanel === 'panel7'} onChange={handleChange('panel7')} className="mt-3">
                    <AccordionSummary
                        className="accordion-header"
                    >
                        {renderTitleWithIcon('panel7', 'E.7 Control activities: Outsourced activities (if applicable)')}
                    </AccordionSummary>
                    <AccordionDetails><E7OutsourcedActivities ref={autoSaveForE7} vesselMstId={vesselMstId} E7OutsourcedActivitiesData={data?.e7ControlActivities} refetchMonitoringData={refetchMonitoringData} />
                    </AccordionDetails>
                </Accordion>

                <Accordion expanded={expandedPanel === 'panel8'} onChange={handleChange('panel8')} className="mt-3">
                    <AccordionSummary
                        className="accordion-header"
                    >
                        {renderTitleWithIcon('panel8', 'E.8 Control activities: Documentation')}
                    </AccordionSummary>
                    <AccordionDetails><E8Documentation ref={autoSaveForE8} vesselMstId={vesselMstId} E8DocumentationData={data?.e8ControlActivities} refetchMonitoringData={refetchMonitoringData} />
                    </AccordionDetails>
                </Accordion>
            </form>
        </FormProvider>

    );
};

export default Management;